const MEANINGLESS_OPTION_LABELS = new Set([
  'desconocido',
  'unknown',
  'no aplica',
  'not applicable',
  'no informado',
  'not informed',
  'no disponible',
  'not available',
  'sin informacion',
  'sin información',
  'n/a',
  'na',
  'null',
  'undefined',
  'desconhecido',
  'desinformado',
  'nao se aplica',
  'não se aplica',
  'nie ma zastosowania',
  'niedoinformowany',
  'nieznajomy'
]);

const normalizeLabel = (value: unknown): string => String(value || '')
  .normalize('NFD')
  .replace(/[\u0300-\u036f]/g, '')
  .toLowerCase()
  .replace(/\s+/g, ' ')
  .trim();

export const isMeaninglessOption = (option: unknown): boolean => {
  const candidate = option && typeof option === 'object' ? option as Record<string, unknown> : {};
  const label = candidate.name ?? candidate.nombre ?? candidate.label ?? candidate.value;
  return MEANINGLESS_OPTION_LABELS.has(normalizeLabel(label));
};

export const filterMeaningfulOptions = <T>(options: T[]): T[] =>
  options.filter((option) => !isMeaninglessOption(option));
